export enum SliderLabelPosition {
  CENTER = 'center',
  SPACE_BETWEEN = 'space-between',
  NONE = 'none',
}
